import React from 'react';
import { M80MediaAndTextBundleModule } from '~/lib/data-contract';
import { MaxWidth } from '~/shared/components/MaxWidth';
import {
    StyledScrollArea,
    StyledScrollbar,
    StyledThumb,
    StyledViewport,
} from '~/shared/components/ScrollArea/styled';
import { ModuleContainer } from '../ModuleContainer';
import { ModuleHeader } from '../ModuleHeader';
import { Article } from './components/Article';
import { useItemMapper } from './hooks';
import { StyledArticleWrapper } from './styled';
import { useModuleTheme } from '../../hooks/useModuleTheme';

/** First cards in the horizontal row: likely visible on load when the module is high on the page. */
const PRIORITY_IMAGE_CARD_COUNT = 5;

export type M80MediaTextBundleProps = M80MediaAndTextBundleModule;

export const M80MediaTextBundle = ({
    headline,
    callToAction,
    mediaAndTextItems,
    priority,
    ...rest
}: M80MediaTextBundleProps) => {
    const articles = useItemMapper(mediaAndTextItems);
    const { textColor } = useModuleTheme(rest);
    return (
        <ModuleContainer fullWidth {...rest}>
            <StyledScrollArea type="auto">
                <MaxWidth>
                    <ModuleHeader headline={headline} link={callToAction} textColor={textColor} />
                </MaxWidth>

                <StyledViewport>
                    <MaxWidth>
                        <StyledArticleWrapper>
                            {articles.map((mediaText, index) => (
                                <Article
                                    key={index}
                                    {...mediaText}
                                    priority={!!priority && index < PRIORITY_IMAGE_CARD_COUNT}
                                />
                            ))}
                        </StyledArticleWrapper>
                    </MaxWidth>
                </StyledViewport>

                <MaxWidth>
                    <div css={{ position: 'relative' }}>
                        <StyledScrollbar orientation="horizontal">
                            <StyledThumb />
                        </StyledScrollbar>
                    </div>
                </MaxWidth>
            </StyledScrollArea>
        </ModuleContainer>
    );
};
